import tournamentIcons from "../data/tournamentIcons";

// const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24h in ms - use in period no new tournaments are going to be added soon
const CACHE_DURATION = 1 * 60 * 60 * 1000; // 1h in ms

export const getTournamentData = async (fetchTournaments) => {
    try {
        const cached = localStorage.getItem("tournamentData");

        if (cached) {
            const cache = JSON.parse(cached);
            if (
                cache.cachedAt &&
                (Date.now() - cache.cachedAt < CACHE_DURATION)
            ) {
                return {
                    tournaments: cache.tournaments || [],
                    seasons: cache.seasons || []
                }
            }
        }
    } catch (err) {
        localStorage.removeItem("tournamentData");
    }

    const response = await fetchTournaments();

    const data = {
        tournaments: response.data?.tournaments || [],
        seasons: response.data?.seasons || [],
        cachedAt: Date.now()
    };

    localStorage.setItem(
        "tournamentData",
        JSON.stringify(data)
    );

    return {
        tournaments: data.tournaments,
        seasons: data.seasons
    };
};

export const buildTournamentMap = (
    tournaments = []
) => {
    return tournaments.reduce((acc, tournament) => {
        acc[tournament.id] = tournament;

        return acc;

    }, {});
};

export const buildSeasonMap = (seasons = []) =>
    seasons.reduce((acc, season) => {
        acc[season.id] = season;
        return acc;
    }, {});

export const getActiveTournaments = (tournaments = []) =>
    tournaments.filter(t => t.status === "live");

export const getTournamentDisplayName = (tournamentName) => {
    return `${tournamentIcons[tournamentName] || ""} ${tournamentName}`;
};